
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/collectibles/[projectId]",
      function () {
        return require("private-next-pages/[locale]/collectibles/[projectId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/collectibles/[projectId]"])
      });
    }
  